var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.91845 23.1641C5.33879 23.462 4.68244 22.9413 4.79914 22.2761L6.04373 15.1819L0.760234 10.1469C0.266463 9.67639 0.522063 8.81605 1.18355 8.72208L8.53126 7.67827L11.8074 1.18846C12.1026 0.603848 12.902 0.603848 13.1971 1.18846L16.4733 7.67827L23.821 8.72208C24.4825 8.81605 24.7381 9.67639 24.2443 10.1469L18.9608 15.1819L20.2054 22.2761C20.3221 22.9413 19.6658 23.462 19.0861 23.1641L12.5023 19.7802L5.91845 23.1641Z",
    fill: "#4B57E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueStar);
export default __webpack_public_path__ + "static/media/blue-star.4eb730485899a54d34479bfa8ee034a5.svg";
export { ForwardRef as ReactComponent };